export class ContactDetailsDTO {

    constructor(
        public firstName: string,
        public lastName: string | null,
        public emailAddress: string,
        public phoneNumber: string | null
    ) { }
}
